import dayjs from 'dayjs';
import { motion } from 'framer-motion';
import { useState } from 'react';
import { Empty, Tag, Tooltip } from 'antd';
import { faClipboardCheck, faListDots } from '@fortawesome/free-solid-svg-icons';

//STYLES
import { CardInfo, Container } from "./style";

//APP
import { atividadesPorTipo } from '../meta';
import { Item__EquipeCliente } from '../../../../../../../../services/Equipe/GET';
import { filtarAtividadesSaida } from '../../meta';
import { leadZero, transition_default } from '../../../../../../../../utils';

//COMPONENTS
import Tabs from '../../../../../../../../Components/Tabs';
import { RowItem } from '../../../../../../../../Components/CustomUi/table/rowItem';
import { RowTable } from '../../../../../../../../Components/CustomUi/table/rowTable';
import { BodyTable } from '../../../../../../../../Components/CustomUi/table/bodyTable';
import { HeaderTable } from '../../../../../../../../Components/CustomUi/table/headerTable';
import { AnimatedPercentage } from '../..';

//PROPS
interface Props {
    atividades_filtradas: filtarAtividadesSaida[];
    detalhes: {
        area_total: number,
        area_executada: number,
        qtd_planejadas: number,
        qtd_executadas: number,
        qtd_concluidas: number,
    };
    porcentagem_selecionada: number;
    data_equipe_cliente: Item__EquipeCliente[];
    cod_talhao_selecionado: number;
}

export const ModalDetalhesAtvsTalhao: React.FC<Props> = ({ atividades_filtradas, detalhes, porcentagem_selecionada = 0, data_equipe_cliente }) => {

    //@ts-ignore CONST
    const atividades_do_talhao = (atividades_filtradas ?? []).map(i => i.lista_atividades)?.flat()

    //STATES
    const [tab_selecionada, setTab_selecionada] = useState<'Executadas' | 'Planejadas'>('Executadas');

    return (
        <Container>
            <div className="Container__stats">
                <Card
                    label="Área total"
                    value={detalhes?.area_total.toFixed(2) + ' ha'}
                />
                <Card
                    label="Área executada"
                    value={detalhes?.area_executada.toFixed(2) + ' ha'}
                    color="gray"
                />
                <Card
                    label="Planejadas"
                    value={leadZero(detalhes?.qtd_planejadas)}
                    color="purple"
                />
                <Card
                    label="Executadas"
                    value={leadZero(detalhes?.qtd_executadas)}
                    color="blue"
                />
                <Card
                    label="Concluídas"
                    value={leadZero(detalhes?.qtd_concluidas)}
                    color="green"
                />
                <div className="Container__stats__percent">
                    <div className="Container__stats__percent__bar">
                        <div className="Container__stats__percent__bar__track">
                            <motion.div
                                className="Container__stats__percent__bar__track__progress"
                                initial={{ width: '0%' }}
                                animate={{ width: `${Number(porcentagem_selecionada <= 100 ? porcentagem_selecionada : 100).toFixed(2)}%` }}
                                transition={{ ...transition_default, delay: 1 }}
                                data-overlap={Number(porcentagem_selecionada) > 100}
                                data-overlap_150={Number(porcentagem_selecionada) > 150}
                                data-overlap_200={Number(porcentagem_selecionada) > 200}
                                data-overlap_250={Number(porcentagem_selecionada) > 250}
                                data-overlap_300={Number(porcentagem_selecionada) > 300}
                            />
                        </div>
                        <AnimatedPercentage value={Number(porcentagem_selecionada)} />
                    </div>
                </div>
            </div>

            <Tabs
                tabs={[{ descricao: 'Executadas', icone: faClipboardCheck }, { descricao: 'Planejadas', icone: faListDots },]}
                selecionado={tab_selecionada}
                onChange={setTab_selecionada}
                width={355}
            />

            {tab_selecionada === 'Executadas' && (<>
                <HeaderTable
                    itens={[
                        { valor: 'Operação', width: 130 },
                        { valor: 'Atividade', width: 'calc(100% - 510.5px)' },
                        { valor: 'Data', width: 100 },
                        { valor: 'Operador', width: 180 },
                        { valor: 'Área', width: 100 },
                    ]}
                />
                <BodyTable style={{ overflowY: 'hidden' }}>
                    {(atividadesPorTipo(atividades_do_talhao ?? [], tab_selecionada, data_equipe_cliente) ?? []).map(({ tipo_operacao, descricao, data_inicio_atv, area, operador_nome }, i) => {
                        return (
                            <RowTable key={i + 'atvs_exec' + tipo_operacao}>
                                <RowItem width={130}>
                                    {tipo_operacao}
                                </RowItem>
                                <RowItem width={'calc(100% - 510px)'} style={{ textTransform: 'capitalize', fontWeight: 600, fontSize: 13 }}>
                                    {String(descricao).toLowerCase()}
                                </RowItem>
                                <RowItem width={100}>
                                    {dayjs(data_inicio_atv).format('DD/MM/YY')}
                                </RowItem>
                                <RowItem width={180} style={{ textTransform: 'capitalize' }}>
                                    {String(operador_nome).toLowerCase()}
                                </RowItem>
                                <RowItem width={100}>
                                    {area} ha
                                </RowItem>
                            </RowTable>
                        )
                    })}

                    {(atividadesPorTipo(atividades_do_talhao ?? [], tab_selecionada, data_equipe_cliente) ?? []).length === 0 && (
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description='Nenhum execução encontrada neste talhão!' />
                    )}

                </BodyTable>
            </>)}

            {tab_selecionada === 'Planejadas' && (<>
                <HeaderTable
                    itens={[
                        { valor: 'Operação', width: 130 },
                        { valor: 'Atividade', width: 'calc(100% - 650px)' },
                        { valor: 'Dias', width: 60 },
                        { valor: 'Data', width: 160 },
                        { valor: 'Conclusão', width: 100 },
                        { valor: 'Patrimônios', width: 110 },
                        { valor: 'Insumos', width: 90 },
                    ]}
                />
                <BodyTable style={{ overflowY: 'hidden' }}>
                    {(atividadesPorTipo(atividades_do_talhao ?? [], tab_selecionada, data_equipe_cliente) ?? []).map(({ tipo_operacao, descricao, data_inicio,
                        dias, data_conclusao, data_final, andamentos, tipo_referencia }, i) => {
                        //@ts-ignore
                        let patrimonios = (andamentos ?? []).flat()?.map(i => i.patrimonios)?.flat().map(j => { return { patrimonio_nome: j?.patrimonio_nome } })?.filter(k => k?.patrimonio_nome !== undefined);
                        //@ts-ignore
                        let insumos = (andamentos ?? []).flat()?.map(i => i.insumos)?.flat().map(j => { return { insumo_nome: j?.insumo_nome } }).filter(k => k?.insumo_nome !== undefined);
                        return (
                            <RowTable key={i + 'atvs_plan' + descricao}>
                                <RowItem width={130}>
                                    {tipo_operacao}
                                </RowItem>
                                <RowItem width={'calc(100% - 650px)'} style={{ textTransform: 'capitalize', fontWeight: 600, fontSize: 13 }}>
                                    {String(descricao).toLowerCase()}
                                </RowItem>
                                <RowItem width={60} style={{ padding: 0 }}>
                                    <div style={{
                                        position: 'relative', width: 60, height: 54.2,
                                        background: Number(dias) == 0 ? 'var(--atv-positivo)' : (Number(dias) < 0 ? 'var(--atv-negativo-light)' : 'var(--atv-positivo-light)'),
                                        padding: 10, display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        color: Number(dias) == 0 ? 'white' : (Number(dias) < 0 ? 'var(--atv-negativo)' : 'var(--atv-positivo)'), fontWeight: 600
                                    }}
                                    >
                                        {Number(dias) > 0 ? '+' : ''}{dias}

                                        <div style={{
                                            width: 10,
                                            height: 4,
                                            background: (Number(dias) < 0 ? 'var(--atv-negativo)' : 'var(--atv-positivo)'),
                                            position: 'absolute',
                                            top: 5,
                                            left: tipo_referencia === 1 ? 2 : (tipo_referencia === 2 ? 25 : 48),
                                            borderRadius: '5px'
                                        }}></div>
                                    </div>
                                </RowItem>
                                <RowItem width={160} style={{ fontSize: 13 }}>
                                    {dayjs(data_inicio).format('DD/MM/YY')} - {dayjs(data_final).format('DD/MM/YY')}
                                </RowItem>
                                <RowItem width={100}>
                                    {data_conclusao ? dayjs(data_conclusao).format('DD/MM/YY') : ''}
                                </RowItem>
                                <RowItem width={110}>
                                    <Tooltip title={patrimonios.length > 0 ? (patrimonios ?? []).map((i) => { return (<>- {String(i.patrimonio_nome)}<br /></>) }) : undefined}>
                                        <div style={{
                                            width: 30, height: 30, borderRadius: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                            background: Number(dias) == 0 ? 'var(--atv-positivo)' : (Number(dias) < 0 ? 'var(--atv-negativo-light)' : 'var(--atv-positivo-light)'),
                                            color: Number(dias) == 0 ? 'white' : (Number(dias) < 0 ? 'var(--atv-negativo)' : 'var(--atv-positivo)'), fontWeight: 600,
                                            opacity: (patrimonios ?? [])?.length === 0 ? 0.3 : 1
                                        }}
                                        >
                                            {leadZero((patrimonios ?? [])?.length)}
                                        </div>
                                    </Tooltip>
                                </RowItem>
                                <RowItem width={90}>
                                    <Tooltip title={insumos?.length > 0 ? (insumos ?? []).map((i) => { return (<>- {String(i.insumo_nome)}<br /></>) }) : undefined}>
                                        <div style={{
                                            width: 30, height: 30, borderRadius: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                            background: Number(dias) == 0 ? 'var(--atv-positivo)' : (Number(dias) < 0 ? 'var(--atv-negativo-light)' : 'var(--atv-positivo-light)'),
                                            color: Number(dias) == 0 ? 'white' : (Number(dias) < 0 ? 'var(--atv-negativo)' : 'var(--atv-positivo)'), fontWeight: 600,
                                            opacity: (insumos ?? [])?.length === 0 ? 0.3 : 1
                                        }}
                                        >
                                            {leadZero((insumos ?? [])?.length)}
                                        </div>
                                    </Tooltip>
                                </RowItem>
                            </RowTable>
                        )
                    })}

                    {(atividadesPorTipo(atividades_do_talhao ?? [], tab_selecionada, data_equipe_cliente) ?? []).length === 0 && (
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description='Nenhuma atividade planejada encontrada neste talhão!' />
                    )}

                </BodyTable>
            </>)}


        </Container>
    )
};




interface PropsCard {
    label: string;
    value: string;
    color?: 'gray' | 'blue' | 'green' | 'purple'
}
const Card: React.FC<PropsCard> = ({ label, value, color }) => {
    return (
        <CardInfo data-color={color}>
            {label}
            <span>{value}</span>
        </CardInfo>
    )
}